<template>
  <div>
    <div class="w-100 d-flex justify-content-center">
      <div class="text-center">
        <img alt="Vue logo" src="../assets/img/mascote.png" height="150">
        <hr>
        <div>
          <h4>Bem vindo mais uma vez {{ user.name }}</h4>
        </div>
        <hr>
        <p><small><b>Acesso rápido</b></small></p>
        <div class="d-flex justify-content-around">
          <router-link to="/students"><i class="fa fa-user-graduate"></i> Alunos</router-link>
          <router-link to="/sells"><i class="fa fa-dollar-sign"></i> Vendas</router-link>
          <router-link to="/courses"><i class="fa fa-book-open"></i> Cursos</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  computed: {
    ...mapGetters({
      user: 'getCurrentUser'
    })
  }
}
</script>
